//竞价公告api
import request from "../utils/request";




export function executeBillQuery(data){
    // console.log('登录')
    // console.log(data)
    return request({
        method:'POST',
        url:'/Kingdee.BOS.WebApi.ServicesStub.DynamicFormService.ExecuteBillQuery.common.kdsvc',
        data:data
    })
}

export function billView(data){
    return request({
        method:'POST',
        url:'/Kingdee.BOS.WebApi.ServicesStub.DynamicFormService.View.common.kdsvc',
        data:data
    })
}


export function save(data){
    return request({
        method:'POST',
        url:'/Kingdee.BOS.WebApi.ServicesStub.DynamicFormService.Save.common.kdsvc',
        data:data
    })
}

export function submit(data){
    return request({
        method:'POST',
        url:'/Kingdee.BOS.WebApi.ServicesStub.DynamicFormService.Submit.common.kdsvc',
        data:data
    })
}

//报名自定义接口
export function enrollIn(data){
    return request({
        method:'POST',
        url:'/Kingdee.TLSY.Bid.WebApi.ServicePlugIn.BidEnrollIn.CustomerEnrollIn,Kingdee.TLSY.Bid.WebApi.ServicePlugIn.common.kdsvc',
         data:{"parameters":data}
        // data:{
    
        //     "parameters":[{
        //         "FId":"111",
        //         "CustomerId":"222",
        //         "BillNo":"33334444445555555555"
        //         }]
            
        // }
    })
}


//结束项目
export function bidEndAuction(data){
    return request({
        method:'POST',
        url:'/Kingdee.TLSY.Bid.WebApi.ServicePlugIn.BidAuction.EndAuction,Kingdee.TLSY.Bid.WebApi.ServicePlugIn.common.kdsvc',
         data:{"parameters":data}
    })
}

//自由竞价出价
export function freeAuctionPrice(data){
    return request({
        method:'POST',
        url:'/Kingdee.TLSY.Bid.WebApi.ServicePlugIn.BidAuction.FreeAuctionPrice,Kingdee.TLSY.Bid.WebApi.ServicePlugIn.common.kdsvc',
         data:{"parameters":data}
    })
}

